import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-lg panel border border-border p-8">
        <div className="text-2xl font-bold text-foreground">Page not found</div>
        <div className="text-sm text-muted-foreground mt-2">
          The page you are trying to open doesn’t exist.
        </div>
        <div className="mt-6 flex flex-wrap gap-3">
          <Link to="/" className="btn btn-primary">Go to portal selector</Link>
          <Link to="/customers/login" className="btn btn-outline-primary">Customer Login</Link>
        </div>
      </div>
    </div>
  );
}
